import React, {Component} from 'react';
import TextField from '@mui/material/TextField';

class DatePicker extends Component {

  constructor (props) {
    super(props)
    this.state = {value: ''}
  }

  handleChange = (event) => {
    const newValue = event.target.value;
    this.setState({value: newValue});
    this.props.onChange({target: {value: newValue, id: this.props.id}});
  };

  render () {
    let inputType = 'datetime-local';
    let label = this.props.label || 'Fecha y Hora';
    
    if (this.props.inputFormat === 'date') {
      inputType = 'date';
      label = this.props.label || 'Fecha';
    } else if (this.props.inputFormat === 'time') {
      inputType = 'time';
      label = this.props.label || 'Hora';
    }

    return (
      <TextField
        fullWidth
        margin="normal"
        type={inputType}
        id={this.props.id}
        label={label}
        value={this.props.value || ''}
        onChange={this.handleChange}
        disabled={this.props.disabled}
        InputLabelProps={{
          shrink: true,
        }}
      />
    );
  }
}

export default DatePicker;
